import { Injectable } from '@angular/core';
import { Intercom } from '@capacitor-community/intercom';
import { Platform } from '@ionic/angular';
import { AuthService } from 'src/app/shared/services/auth.service';
const intercom = new Intercom();

@Injectable({
    providedIn: 'root'
})
export class IntercomService {
    constructor(private platform: Platform, private auth: AuthService) {}

    public registerUser() {
        if (this.checkPlatform() && this.auth.isAuthenticated) {
            try {
                intercom.registerIdentifiedUser({ userId: this.auth.currentAuth.user.uid });
                return true;
            } catch (error) {
                console.error(error);
                return false;
            }
        }
        return false;
    }

    public logout() {
        if (this.checkPlatform()) {
            try {
                intercom.logout();
            } catch (error) {
                console.error(error);
            }
        }
    }

    private checkPlatform() {
        return this.platform.is('capacitor') || this.platform.is('cordova');
    }
}
